import { AxiosResponse } from 'axios'
import { HttpService } from './common/HttpService'
import {
  SupportDialogQuote,
  SupportDialogReservation,
  SupportDialogQuoteResponse,
  SupportDialogReservationResponse,
} from '@/models/dto/SupportDialog'

const httpService: HttpService = new HttpService()

export default {
  /**
   * Fetches all reservations for the support dialog.
   *
   * @returns A promise that resolves to the reservations.
   */
  fetchReservations(): Promise<AxiosResponse<SupportDialogReservationResponse>> {
    const url = `/charterup/v1/support-dialog/reservations`
    return httpService.get(url)
  },

  /**
   * Fetches a reservation for the support dialog.
   *
   * @param reservationId - The ID of the reservation to fetch.
   * @returns A promise that resolves to the reservation.
   */
  fetchReservation(reservationId: string): Promise<AxiosResponse<SupportDialogReservation>> {
    const url = `/charterup/v1/support-dialog/reservation/${reservationId}`
    return httpService.get(url)
  },

  /**
   * Fetches all quotes for the support dialog.
   *
   * @returns A promise that resolves to the quotes.
   */
  fetchQuotes(): Promise<AxiosResponse<SupportDialogQuoteResponse>> {
    const url = `/charterup/v1/support-dialog/quotes`
    return httpService.get(url)
  },

  /**
   * Fetches a quote for the support dialog.
   *
   * @param quoteId - The ID of the quote to fetch.
   * @returns A promise that resolves to the quote.
   */
  fetchQuote(quoteId: string): Promise<AxiosResponse<SupportDialogQuote>> {
    const url = `/charterup/v1/support-dialog/quote/${quoteId}`
    return httpService.get(url)
  },
}
